import { INITIALIZE_SOCKET } from "../constants";

export const setInializeSocket = (payload) => ({
    type: INITIALIZE_SOCKET,
    payload,
});